








































import { Component, Vue, Prop } from "vue-property-decorator";
import endImg from "@/assets/images/end.png";
import activityArrow from "@/assets/images/activity-arrow.png";

@Component({
  components: {}
})
export default class ActivityItem extends Vue {
  @Prop({ required: true }) private item!: any;
  @Prop({ required: true }) private index!: any;
  endImg = endImg;
  activityArrow = activityArrow;

  extractText(html: any) {
    const div = document.createElement("div");
    div.innerHTML = html;
    return div.textContent || div.innerText || "";
  }
}
